import { useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { PermissionsContext } from "context/AppProvider/PermissionsContext";
import { PERMISSIONS } from "constants/portal";
import { getEnv } from "helpers/environment";

const isActive = (component) => {
  return component === "active";
};

// Checks if a user can access the page
function ProtectedPage({ route, href, children }) {
  const { isLoading } = useAuth0();
  const { userPermissions } = useContext(PermissionsContext);

  const getPermission = (permissionName) => {
    return userPermissions?.find((permission) => permission.name === permissionName)?.value;
  };

  if (isLoading) {
    return <></>;
  }

  const hasAccess = () => {
    if (route) {
      switch (route) {
        case "/administration/company":
          return getPermission(PERMISSIONS.ACCESS_TO_COMPANY_PAGE);
        case "/administration/billing":
          return getPermission(PERMISSIONS.ACCESS_TO_BILLING_PAGE);
        case "/administration/users":
          return getPermission(PERMISSIONS.ACCESS_TO_USERS_PAGE);
        // case "/administration/subscriptions":
        //   return getPermission(PERMISSIONS.ACCESS_TO_SUBSCRIPTIONS_PAGE);
        case "/administration/roles-and-permissions":
          return getPermission(PERMISSIONS.ACCESS_TO_ROLES_AND_PERMISSIONS_PAGE);
        case "/library/flows":
          return getPermission(PERMISSIONS.ACCESS_TO_WORKFLOWS_PAGE);
        case "/administration/account":
          return getPermission(PERMISSIONS.ACCESS_TO_ACCOUNT_PAGE);
        case "/administration/credential-management":
          return getPermission(PERMISSIONS.ACCESS_TO_CREDENTIAL_MANAGEMENT_PAGE);
        case "/quick-start":
          return getPermission(PERMISSIONS.ACCESS_TO_QUICK_START_PAGE);
        case "/analytics/workflows":
          return isActive(getEnv("IS_COMPONENT_DOWN_ANALYTICS_WORK_FLOWS"));
        case "/analytics/integrations":
          return isActive(getEnv("IS_COMPONENT_DOWN_ANALYTICS_INTEGRATIONS"));
        case "/analytics/logs":
          return (
            isActive(getEnv("IS_COMPONENT_DOWN_ANALYTICS_LOGS")) &&
            getPermission(PERMISSIONS.ACCESS_TO_LOGS_PAGE)
          );
        case "/resources/marketplace":
          return isActive(getEnv("IS_COMPONENT_DOWN_MARKET_PLACE"));
        case "/library/connectors":
          return (
            isActive(getEnv("IS_COMPONENT_DOWN_BUILD_CONNECTORS")) &&
            getPermission(PERMISSIONS.ACCESS_TO_CONNECTORS_PAGE)
          );
        case "/library/schedules":
          return getPermission(PERMISSIONS.ACCESS_TO_SCHEDULER_PAGE);
        default:
          return true;
      }
    } else {
      switch (href) {
        case "/designer":
        case "/designer/new":
        case "/designer/:id":
          return getPermission(PERMISSIONS.ACCESS_TO_DESIGNER);
        case "https://support.cxfabric.io/tickets-view?offset=0":
          return getPermission(PERMISSIONS.CREATE_SUPPORT_TICKET);
        case "/scheduler/new":
          return getPermission(PERMISSIONS.ADD_SCHEDULES);
        case "/connector/new":
          return getPermission(PERMISSIONS.CREATE_CONNECTORS);
        default:
          return true;
      }
    }
  };

  return hasAccess() ? children : null;
}

export default ProtectedPage;
